export default "/images/ifforsikringsagentur.webp?aea296d858e243e5e7dceb4b856c4f7a";